import styled from 'styled-components'
import Typography from '@ntuctech/devex-tangram/Typography'
import Modal from '@ntuctech/devex-tangram/Modal'
import ModalContent from '@ntuctech/devex-tangram/ModalContent'
import { SCREEN_SIZE } from '../../lib/Media'

export const StyledTncsModal = styled(Modal)`
  width: 100%;
  ${SCREEN_SIZE.From.MobileL} {
    width: 50%;
  }
`
export const StyledTncsModalBody = styled(ModalContent)`
  max-height: calc(100vh - 18rem);
  padding: 1rem;
  overflow-y: auto;
`

export const Subtitle = styled(Typography)`
  margin: 1rem 0;
`

export const Paper = styled.section`
  max-width: 26.25rem;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 0.25rem;
  border: 0.0625rem solid #e1e1e1;
  overflow: hidden;
  padding: 1rem 1.5rem;
  margin: 0 1rem;
  margin-top: 1rem;

  a {
    text-decoration: none;
    color: #1658bf;
    font-weight: bold;
  }

  ${SCREEN_SIZE.From.Tablet} {
    margin-top: 0;
  }
`

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  min-height: 100vh;
  padding: 1rem 0;

  &[data-hidden='true'] {
    display: none;
  }

  &[data-component='loader'] {
    align-items: center;
  }

  ${SCREEN_SIZE.From.Tablet} {
    align-items: center;
  }
`
